import { z } from 'zod';

import { SupporterPostBase } from '../proxy-api/supporter.ts';

export const AccountCreatePayload = SupporterPostBase.extend({
  uniqueId: z.string().min(1),
});

export type AccountCreatePayload = z.infer<typeof AccountCreatePayload>;
